import React from 'react';
import {Link} from 'react-router-dom';
import { FiMapPin, FiPhone, FiMail, FiFacebook, FiInstagram, FiTwitter, FiYoutube, FiLinkedin } from "react-icons/fi";

export default function Footer() {
    return (
        <div className='container-fluid bg-dark text-white footer' >
            <div className="row">
                <div className="col-sm-12 col-md-4">
                    <div className='container mt-5'>
                        <img className='footer-logo img-fluid mb-3' src="./assets/images/amosta -living technology (White).png" alt="" />
                        <p align='justify' className='footer-text'>Amosta is a Technology Company, Committed to Cater The Requirements of THE PEOPLE to live a Better & Happy Life in era of Internet Of Things, Futuristic Smart Cities, Connected World & Super Intelligent Ecosystem.</p>
                        <div className="social-icons-many">
                            <div className="social-icon">
                                <a className='icon' target='_blank' rel="noopener noreferrer" href="https://www.facebook.com/amostasolutions/"><FiFacebook /></a>
                            </div>
                            <div className="social-icon">
                                <a className='icon' target='_blank' rel="noopener noreferrer" href="https://www.instagram.com/amostasolutions/?hl=en"><FiInstagram /></a>
                            </div>
                            <div className="social-icon">
                                <a className='icon' target='_blank' rel="noopener noreferrer" href="https://twitter.com/amostasolutions"><FiTwitter /></a>
                            </div>
                            <div className="social-icon">
                                <a className='icon' target='_blank' rel="noopener noreferrer" href="https://www.linkedin.com/company/amosta-solutions-pvt--ltd-/mycompany/"><FiLinkedin /></a>
                            </div>
                            <div className="social-icon">
                                <a className='icon' target='_blank' rel="noopener noreferrer" href="https://www.youtube.com/c/AmostaSolutions"><FiYoutube /></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-12 col-md-2">
                    <div className="container mt-5">
                        <h4 className='mb-4 mt-5'>Quick Links</h4>
                        <Link to="/" className='footer-text-link'>
                        <span className='footer-text-link'>Home</span>
                        </Link>
                        <hr />
                        <Link to='/gst-robo' className='footer-text-link'>
                        <span className='footer-text-link'>GST Robo</span>
                        </Link>
                        <hr />
                        <Link to='/led-lights' className='footer-text-link'>
                        <span className='footer-text-link'>LED Lights</span>
                        </Link>
                        <hr />
                        <Link to='/about-acp' className='footer-text-link'>
                        <span className='footer-text-link'>ACP</span>
                        </Link>
                        <hr />
                    </div>
                </div>
                <div className="col-sm-12 col-md-2">
                    <div className="container mt-5">
                        <h4 className='mb-4 mt-5'>Useful Links</h4>
                        <Link to='/contact-us' className='footer-text-link'>
                        <span className='footer-text-link'>Contact Us</span>
                        </Link>
                        <hr />
                        <Link to='/contact-us' className='footer-text-link'>
                        <span className='footer-text-link'>Career</span>
                        </Link>
                        <hr />
                        <Link to='/whoweare' className='footer-text-link'>
                        <span className='footer-text-link'>Who We Are</span>
                        </Link>
                        <hr />
                        <Link to='/about-acp' className='footer-text-link'>
                        <span className='footer-text-link'>ACP</span>
                        </Link>
                        <hr />
                    </div>
                </div>
                <div className="col-sm-12 col-md-4">
                    <div className="container footer-left-container mt-5">
                        <div className="row">
                            <div className="col-1">
                                <p><FiMapPin /></p>
                            </div>
                            <div className="col-11">
                                <p className='footer-text' align='justify'>301-B, Flatted Factory Complex, Hartron Technology Park Plot No. 25A, Electronic City, Sector 18, Gurugram, Haryana 122015</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-1">
                                <p><FiPhone /></p>
                            </div>
                            <div className="col-11">
                                <p align='justify'><a className='footer-text' style={{color: 'white'}} href="tel:+91-8750060033">+91-87500 60033</a></p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-1">
                                <p><FiMail /></p>
                            </div>
                            <div className="col-11">
                                <p align='justify'><a className='footer-text' style={{color: 'white'}} href="mailto:sales@amosta.com">sales@amosta.com</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
